import script from "./slug.vue?vue&type=script&setup=true&lang=ts"
export * from "./slug.vue?vue&type=script&setup=true&lang=ts"

import "./slug.vue?vue&type=style&index=0&id=31cf333f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31cf333f"]])

export default __exports__